import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewEncapsulation,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { fuseAnimations } from "@fuse/animations";
import { AuthService } from "app/base-module/base-service/auth.service";
import { Usuario } from "app/usuarios/models/user.model";
import { ActionDialog, BaseComponent } from "../../base-module/base-component/base.component";
import { ICarta } from "../cadastro-boleta-consorcio/cadastro-boleta-consorcio.component";
import { CartaBoletaConsorcioService } from "../services/carta-boleta-consorcio.service";
import {
    CadastroCartaBoletaConsorcio,
    CadastroCartaBoletaConsorcioProps,
} from "./cadastro-carta-boleta-consorcio.component";

@Component({
    selector: "app-lista-carta-boleta-consorcio",
    templateUrl: "./lista-carta-boleta-consorcio.component.html",
    styleUrls: ["./lista-carta-boleta-consorcio.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    providers: [],
})
export class ListaCartaBoletaConsorcio extends BaseComponent implements OnInit, OnChanges {
    user: Usuario | null = null;

    @Input()
    boletaId!: string;

    @Input()
    parceiroConsorcioId!: string;

    @Input()
    filter: any = {};

    @Output() eventoEdicaoCarta = new EventEmitter();

    constructor(
        public _service: CartaBoletaConsorcioService,
        public dialog: MatDialog,
        override snackBar: MatSnackBar,
        private _authService: AuthService
    ) {
        super(dialog, snackBar);

        this.pageSizeOptions = [10, 25, 50, 100, 200];
        this.pageSize = 10;
        this.params.per_page = this.pageSize;
        this.rows = [];
    }

    /**
     * Inicializa o componente carregando dados do usuário e listando cartas
     */
    ngOnInit(): void {
        const strUser = this._authService.getUser();
        this.user = JSON.parse(strUser ? strUser : "{}");
        this.params.boleta_id = this.boletaId;
        this.getAll();
    }

    /**
     * Atualiza a lista quando o filtro é alterado
     * @param changes - Mudanças detectadas nos inputs
     */
    ngOnChanges(changes: SimpleChanges): void {
        if (changes && changes["filter"]) {
            this.params = {
                ...this.params,
                ...changes["filter"].currentValue,
                boleta_id: this.boletaId,
            };
            this.getAll();
        }
    }

    /**
     * Evento da paginação
     * @param event - Evento de mudança de página
     */
    pageEvent(event: PageEvent): void {
        this.params.page = event.pageIndex + 1;
        this.params.per_page = event.pageSize;
        this.params.boleta_id = this.boletaId;

        this.getAll();
    }

    /**
     * Consulta lista de Cartas
     */
    getAll(): void {
        this.loadingIndicator = true;
        this._service.getAll(this.params).subscribe({
            next: (data) => {
                this.length = data.meta.total;
                this.rows = data.data || [];
                this.temp = [...this.rows];
            },
            error: (error) => {
                this.loadingIndicator = false;
                this.rows = [];
                this.showError(`Erro ao buscar cartas: ${error.error?.message || error.message}`);
            },
            complete: () => {
                this.loadingIndicator = false;
            },
        });
    }

    /**
     * Emite evento de edição de carta para o componente pai
     * @param row - Dados da carta a ser editada
     * @param index - Índice da carta na lista
     */
    enviarEventoEdicao(row: ICarta, index: number): void {
        this.eventoEdicaoCarta.emit({ row: row, index });
    }

    /**
     * Abre diálogo para editar uma carta existente
     * @param cartaId - Identificador da carta a ser editada
     */
    openAlterarCarta(cartaId: number): void {
        const dialogRef = this.dialog.open<CadastroCartaBoletaConsorcioProps, CadastroCartaBoletaConsorcioProps>(
            CadastroCartaBoletaConsorcio,
            {
                width: "800px",
                maxHeight: "99vh",
                data: {
                    boletaId: Number(this.boletaId),
                    cartaId,
                    parceiroConsorcioId: Number(this.parceiroConsorcioId),
                    cartaEdit: null,
                },
            }
        );

        dialogRef.afterClosed().subscribe({
            next: (result) => {
                if (result === "reload-list") {
                    this.getAll();
                }
            },
        });
    }

    /**
     * Exclui Carta
     * @param id - Identificador da carta a ser excluída
     */
    delete(id: number): void {
        this.dialog.open(ActionDialog, {
            width: "250px",
            disableClose: true,
            data: {
                title: "Excluir Carta",
                text: "Deseja realmente excluir este item?",
                callback: () => {
                    this.dialog.closeAll();

                    this.loadingIndicator = true;
                    this._service.delete(id).subscribe({
                        next: (data) => {
                            this.loadingIndicator = false;
                            this.showSuccess(data.message);
                            this.getAll();
                        },
                        error: (error) => {
                            this.loadingIndicator = false;
                            this.showError(`Erro ao excluir carta: ${error.error?.message || error.message}`);
                        },
                        complete: () => {
                            // Loading será fechado em next ou error
                        },
                    });
                },
            },
        });
    }
}
